export const threatEventKeys = {
  all: ["threatEvents"] as const,
  categories: (projectId: string) => [...threatEventKeys.all, "categories", projectId] as const,
  project: (projectId: string, variantId: string) => [...threatEventKeys.all, "project", projectId, variantId] as const,
};
